// added because media selectors get to long and prettier decide to put the into two separate lines
// beacause of that a error appears in code
export const getBP = (theme, breakpoint) => theme.myBreakpoints[breakpoint];

export const onlyMd = (theme) => ({ min: theme.myBreakpoints["md"], max: "1279.95px" });
